import { render, staticRenderFns } from "./ShareBtn.vue?vue&type=template&id=ab43ad8a&"
import script from "./ShareBtn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ShareBtn.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab43ad8a')) {
      api.createRecord('ab43ad8a', component.options)
    } else {
      api.reload('ab43ad8a', component.options)
    }
    module.hot.accept("./ShareBtn.vue?vue&type=template&id=ab43ad8a&", function () {
      api.rerender('ab43ad8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ShareBtn/ShareBtn.vue"
export default component.exports